import React from "react";

const Footer = () => {
  return (
    <div className="bg-white border-t border-gray-200">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row justify-between items-center py-0">
          {/* Left Section - Logo & Description */}
          <div className="md:w-1/3 text-center md:text-left mb-4 md:mb-0">
            <div className="flex items-center justify-center md:justify-start space-x-1">
              <img
                src="/images/main-logo.jpg"
                alt="HouseKeeper Logo"
                className="h-14 w-auto" 
              />
            </div>
            <p className="text-gray-600  text-xs leading-relaxed max-w-md"> {/* Reduced text size */}
              A smart technology platform that enables hosts and property
              managers to centralize and control all their cleaning management
              from one place.
            </p>
          </div>

          {/* Contact Information */}
          <div className="md:w-1/3 text-center md:text-left">
            <h3 className="text-sm font-semibold text-gray-800"> {/* Reduced text size */}
              Contact Information
            </h3>
            <p className="text-gray-600 text-xs mt-1"> {/* Reduced text size */}
              📞 +44 7414 747861 <br />
              📧 hello@housekeeper.host <br />
              📍 86-90 Paul Street, London EC2A 4NE
            </p>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center text-gray-600 text-xs border-t border-gray-300 pt-2 mb-2"> 
          <p className="text-center md:text-left">
            Copyright © FunSpex Limited, trading as HouseKeeper, 2026. All
            rights reserved.
          </p>
          <div className="flex space-x-4 mt-2 md:mt-0">
            <a
              href="https://housekeeper.host/privacy-policy"
              target="__blank"
              className="hover:text-gray-800 hover:underline text-xs" 
            >
              Privacy Policy
            </a>
            <a
              href="https://housekeeper.host/terms-of-service"
              target="__blank"
              className="hover:text-gray-800 hover:underline text-xs" 
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;